import { PartnerCenterEnrollmentStatus } from "@gamedev-web/one-gaming-crm";

export const isPartnerCenterEnrollmentFinished = (
  enrollmentStatus: PartnerCenterEnrollmentStatus | undefined
): boolean =>
  enrollmentStatus === PartnerCenterEnrollmentStatus.Complete ||
  enrollmentStatus === PartnerCenterEnrollmentStatus.EarlyComplete ||
  enrollmentStatus === PartnerCenterEnrollmentStatus.Rejected ||
  enrollmentStatus === PartnerCenterEnrollmentStatus.EarlyRejected;
